/**
 * Signalements des spectateurs, tels que les rend admin-api
 * (ReportModerationStore) : une vidéo ou une chaîne, le motif choisi dans le
 * lecteur du portail, et la décision prise dans la régie.
 */

export type ReportStatus = 'open' | 'resolved' | 'dismissed';
export type ReportKind   = 'video' | 'channel';

export interface ReportItem {
  kind         : ReportKind;
  id           : number;
  reasonCode   : string;
  text         : string | null;
  creationDate : string | null;
  reporter     : { userId: number | null; email: string | null; ip: string | null };
  target       : {
    id          : number | null;
    title       : string;
    slug        : string | null;
    deleted     : boolean;
    visible     : boolean;
    creator     : string | null;
    openReports : number;
  };
  status       : ReportStatus;
  decisionNote : string | null;
  decisionDate : string | null;
  decidedBy    : string | null;
  /** Quand la décision a été envoyée par e-mail à l'auteur du signalement. */
  notificationDate? : string | null;
}

export interface ReportList {
  reports : ReportItem[];
  counts  : Record<ReportStatus, number>;
}

/** Les motifs du lecteur du portail (REPORT_REASONS, Player.tsx) : mêmes codes. */
export const REPORT_REASON_LABELS: Record<string, string> = {
  sexual_content         : 'Contenu à caractère sexuel',
  violent_or_shocking    : 'Contenu violent ou choquant',
  hateful_or_abusive     : 'Contenu haineux ou abusif',
  harassment             : 'Harcèlement ou intimidation',
  dangerous_acts         : 'Actes dangereux ou nuisibles',
  misleading_information : 'Informations trompeuses',
  spam_or_scam           : 'Spam ou contenu mensonger',
  rights_infringement    : 'Atteinte à ses droits',
};

/** Les motifs les plus graves passent devant : mineurs, violence, haine. */
export const URGENT_REASONS = new Set(['sexual_content', 'violent_or_shocking', 'hateful_or_abusive', 'dangerous_acts']);

export const REPORT_STATUS_LABELS: Record<ReportStatus, string> = {
  open      : 'À traiter',
  resolved  : 'Contenu retiré',
  dismissed : 'Classé sans suite',
};
